<template>
  <!--复制设备参数和按键参数-->
  <div id="equipmentCopy" style="width: 100%;height: 100%">
    <!--搜索栏-->
    <div class="search">
      <span>{{$t("equipmentNo")}}：</span><el-input v-model="searchForm.equipmentNo"></el-input>
      <span>{{$t("equipmentName")}}：</span><el-input v-model="searchForm.name"></el-input>
      <el-button type="primary" @click="initTableData(1)">{{$t("search")}}</el-button>
      <el-button type="primary" @click="resetSearch">{{$t("resetSearch")}}</el-button>
      <el-badge :value="choosedTableData.length" class="item">
        <el-button size="small" @click="showChoosedDialog" :class="$i18n.locale=='zh'?'':'englishStyle'"><i class="el-icon-search el-icon--left"></i>{{$t("equipmentmanagement.checkSelectedEquipments")}}</el-button>
      </el-badge>
    </div>
    <div class="table">
      <el-table ref="tableData" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange" @filter-change="filterchange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          width="0"
          v-if="false"
          prop="id"
        >
        </el-table-column>
        <el-table-column
          :label="$t('equipmentNo')">
          <template slot-scope="scope">{{ scope.row.number }}</template>
        </el-table-column>
        <el-table-column
          :label="$t('equipmentName')">
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>
        <el-table-column
          column-key="equipmentType"
          :label="$t('equipmentmanagement.machineModel')">
          :filters="equipfilterdata"
          :filter-multiple="false"
          :filter-method="filterHandler"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.equipmentType" >{{scope.row.equipmentType.name}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="SaleWay"
          :label="$t('equipmentmanagement.salesChannel')">
        </el-table-column>
        <el-table-column
          :label="$t('user')">
          <template slot-scope="scope">{{ scope.row.user?scope.row.user.name:'' }}</template>
        </el-table-column>
      </el-table>
    </div>
    <div class="foot">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page=currentlistpage
        :page-sizes="[10, 50, 100, 200]"
        :page-size=pageSize
        layout="total, sizes, prev, pager, next, jumper"
        :total=totalEquipCount>
      </el-pagination>
      <el-divider></el-divider>
      <el-button v-if="equipmentCopyInit.equipmentType.catalog==0 || equipmentCopyInit.equipmentType.catalog==1" @click="copy(1)" type="primary">{{$t('equipmentmanagement.copyEquipmentParameters')}}</el-button>
      <el-button v-if="equipmentCopyInit.equipmentType.catalog==0 || equipmentCopyInit.equipmentType.catalog==1" @click="copy(2)" type="info">{{$t('equipmentmanagement.copyKeyParameters')}}</el-button>
      <el-button v-if="equipmentCopyInit.equipmentType.catalog==1" @click="copy(3)" type="danger">{{$t('equipmentmanagement.copyPictureLibrary')}}</el-button>
      <el-button v-if="equipmentCopyInit.equipmentType.catalog==2" @click="copy(5)">复制dtu按键参数</el-button>
      <el-button v-if="equipmentCopyInit.equipmentType.catalog==2" @click="copy(4)" type="info">{{$t('equipmentmanagement.copyPartOfParameters')}}</el-button>
    </div>
    <el-dialog
      width="60%"
      :title="$t('equipmentmanagement.checkTheSelectedEquipment')"
      :visible.sync="choosedDialog"
      v-if="choosedDialog"
      :close-on-click-modal="false"
      append-to-body>
      <el-card  style="padding:0px !important;box-shadow:none !important; border:solid 1px #DCDFE6;">
        <el-row :gutter="24" class="row">
          <el-col :span="24">
            <el-table
              :data="choosedTableData"
              tooltip-effect="dark"
              :page-size="pageSize"
              max-height="520"
              stripe
            >
              <el-table-column
                type="index"
                :label="$t('serialNo')"
                width="100"
              >
              </el-table-column>
              <el-table-column
                prop="name"
                :label="$t('equipmentName')"
              >
              </el-table-column>
              <el-table-column
                prop="number"
                :label="$t('equipmentNo')">
              </el-table-column>
              <el-table-column
                prop="SaleWay"
                :label="$t('equipmentmanagement.salesChannel')">
              </el-table-column>
              <el-table-column
                :label="$t('operation')"
                fixed="right"
                width="230"
              >
              <template slot-scope="scope">
                <el-button type="danger" icon="el-icon-delete" @click="deleteChoosedEquip(scope.row)" circle></el-button>
              </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-card>
    </el-dialog>
    <el-dialog
      id="partDialog"
      width="60%"
      :title="$t('equipmentmanagement.selectDeviceAndKeyParameters')"
      :visible.sync="choosePartKeyconfig"
      v-if="choosePartKeyconfig"
      :close-on-click-modal="false"
      append-to-body>
      <el-card  style="padding:0px !important;box-shadow:none !important; border:solid 1px #DCDFE6;">
        <el-row :gutter="24" class="row">
          <el-col :span="12">
            <div>{{$t('equipmentmanagement.equipmentParameter')}}</div>
            <el-tree
              ref="equipmentTree"
              :data="[equipmentParameterArrAll]"
              :props="{
                label: 'name',
                children: 'children'
                      }"
              show-checkbox
              @check-change="handleCheckChangeEquipmentParameter">
                <div slot-scope="{ node, data }" style="width: 100%;line-height: 30px">
                  <div style="width: 50%;float: left">{{ node.label }}</div>
                  <el-input v-if="!(data.children && data.children.length)" v-model="data.value" size="mini"></el-input>
                </div>
            </el-tree>
          </el-col>
          <el-col :span="12">
            <div>{{$t('equipmentmanagement.keyParameters')}}</div>
            <el-tree
              ref="keyConfigTree"
              :data="keyConfigArr"
              :props="props"
              show-checkbox
              node-key="id"
              @check-change="handleCheckChangeKeyConfig">
                <span slot-scope="{ node, data }" style="width: 100%;line-height: 30px">
                  <div style="width: 50%;float: left">{{data.keyConfigValuePairs?data.sort+"号键-":""}}{{node.label}}</div>
                  <el-input v-if="!data.keyConfigValuePairs"  v-model="data.value" size="mini"></el-input>
                </span>
            </el-tree>
          </el-col>
        </el-row>
        <el-row id="button_row">
          <el-button @click="copyPartData" type="info">{{$t('equipmentmanagement.copy')}}</el-button>
        </el-row>
      </el-card>

    </el-dialog>
    <el-dialog
      id="dtuDialog"
      width="60%"
      title="复制DTU参数"
      :visible.sync="chooseDtuKeyconfig"
      v-if="chooseDtuKeyconfig"
      :close-on-click-modal="false"
      append-to-body>
      <el-card  style="padding:0px !important;box-shadow:none !important; border:solid 1px #DCDFE6;">
        <el-row :gutter="8" class="row">
          <el-checkbox-group v-model="dtuCheckList" @change="changeDtuList">
            <el-checkbox :label="item.sort"  name="type" @change="changeDtuList" v-for="(item,index) in keyConfigArr" :key="index" border>{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-button @click="copyDtuData" type="info">{{$t('equipmentmanagement.copy')}}</el-button>
        </el-row>
      </el-card>

    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "EquipmentCopy",
  props:
    ['equipmentCopyInit','dtuNumber']
  ,
  data(){
    return{
      // 表格参数
      equipmentParameterArrAll:[],
      tableData:[],
      checkArray:[],// 被选中的
      searchForm:{
        name:null,
        equipmentNo:null,
        equipmentTypeId:null
      },
      currentlistpage:1,
      totalEquipCount:0,// 合计
      pageSize:10,//页数
      choosedIdList:[],
      choosedTableData:[],// 需要回显的id数组
      choosedDialog:false,
      choosePartKeyconfig:false,// 显示局部按键的参数
      chooseDtuKeyconfig:false, // 显示复制dtu设备的参数
      props: {
        label: 'name',
        children: 'keyConfigValuePairs',
      },
      count: 1,
      equipmentParameterArr:[],
      keyConfigArr:[],
      needCopyEquipmentParameterArr:[],// 需要被复制的设备参数
      needCopyKeyConfigArr:[],// 需要被复制的按键参数
      equipfilterdata:[],// 设备类型筛选
      equipTypeList:[],
      filterParam:new Object(),
      dtuCheckList:[],
    }
  },
  created() {
    console.log("参数",this.equipmentCopyInit)
    this.initTableData(1)
    this.initEquipmentParameterTree()
    this.getEquipTypeList()
  },
  methods: {
    filterHandler(value, row,column) {
      return row['equipmentTypeID'] === value;
    },
    handleSizeChange(e) {
      this.pageSize=e;
      this.currentlistpage =1
      this.initTableData(1)
    },
    handleCurrentChange(e) {
      this.pageIndex = e;
      this.currentlistpage = e
      this.initTableData(e)
    },
    handleSelectionChange(val) {
      this.checkArray = val;
      this.checkArray.forEach(item=>{
        if(this.choosedIdList.indexOf(item.id)<0){
          this.choosedIdList.push(item.id)
          this.choosedTableData.push(item)
        }
      })
    },
    //公共筛选方法
    filterchange(filters){
      if(Object.keys(filters)=="equipmentType"){
        if(filters["equipmentType"].length>0){
          let value = filters["equipmentType"][0];
          this.searchForm.equipmentTypeId=value
        }else{
          this.searchForm.equipmentTypeId = null;
        }
        this.initTableData(1);
      }
      return this.searchForm;
    },
    // 打开时，加载数据列表
    initTableData(pageIndex){
      let param = {
        pageIndex:pageIndex,
        pageSize:this.pageSize,
        ...this.searchForm
      }
      this.$httpservice.get('api/Equipment/List',param).then(res=>{
        if(res.status==200){
          this.tableData = res.body.data
          this.totalEquipCount = res.body.totalCount
          this.toggleChecked()
        }
      })
    },
    deleteChoosedEquip(e){
      // 清除表格
      this.choosedTableData.some((item,index)=>{
        if(item.id == e.id){
          this.choosedTableData.splice(index,1)
        }
      })
      this.choosedIdList.some((item,index)=>{
        if(item == e.id){
          this.choosedIdList.splice(index,1)
        }
      })
      this.toggleChecked()
    },
    // 复制参数，type:1设备参数，2按键参数,3图片库，4局部参数
    copy(type){
      // 如果没选择设备，就提示
      if(this.choosedIdList.length<=0){
        this.$message.error(this.$t('equipmentmanagement.pleaseSelectTheEquipmentToBeCopied'))
        return
      }
      // 如果是复制局部按键参数，就弹窗，并且不能操作别的
      if(type == 4){
        this.needCopyEquipmentParameterArr = []
        this.needCopyKeyConfigArr = []
        this.choosePartKeyconfig = true
        return
      }else if(type==5){
        // 如果是复制dtu按键参数，就弹窗，展示这个机型的所有按键
        this.chooseDtuKeyconfig = true
        return
      }
      let data = {}
      data.ids = this.choosedIdList
      data.id = this.equipmentCopyInit.id
      data.type = type
      // 选中的按键序号


      // 调用接口复制
      this.$httpservice.post("api/Equipment/CopyById",data).then(res=>{
        if(res.body.code==200){
          this.$message.success(this.$t('equipmentmanagement.copySucceeded'))
          return
        }else{
          this.$message.error(this.$t('equipmentmanagement.copyFailed')+'['+res.body.msg+']')
          return
        }
      })
    },
    // 初始化按键列表，根据当前被复制设备的按键来定
    initEquipmentParameterTree(){
      // 获取设备参数
      this.$httpservice.get('api/Equipment/GetParameters',{dtuNo:this.equipmentCopyInit.dtuNumber}).then(res=>{
        if(res.body.code == 200){
          this.equipmentParameterArr = res.body.data
          this.equipmentParameterArrAll={
            id:0,
            label:'parent',
            name:'设备参数-全部',
            children:this.equipmentParameterArr
          }
          console.log('111',this.equipmentParameterArrAll)
        }else{
          this.$message.error(this.$t('equipmentmanagement.failedToObtainDeviceParametersPleaseRefreshAndTryAgain'))
        }
      })
      // 获取按键参数
      this.$httpservice.get('api/Equipment/KeyConfigs',{dtuNo:this.equipmentCopyInit.dtuNumber}).then(res=>{
        if(res.body.code == 200){
         this.keyConfigArr = res.body.data
          // 把值附上去
          this.keyConfigArr.forEach(item=>{
            item.keyConfigValuePairs.forEach(item2=>{
              item2.keySort = item.sort
            })
            let tempName = {name:'饮品名称',variableName:'name',value:item.name,sort:item.sort,keySort:0}
            let tempPrice = {name:'价格',variableName: "price",value:item.price,sort:item.sort,keySort:0}
            item.keyConfigValuePairs.unshift(tempPrice)
            item.keyConfigValuePairs.unshift(tempName)
          })
        }else{
          this.$message.error(this.$t('equipmentmanagement.failedToObtainKeyParameter'))
        }
      })
    },
    // 重置搜索框的条件
    resetSearch(){
      this.searchForm = {
        name:'',
        number:''
      }
      this.checkArray = []
      this.initTableData(1)
    },
    // 显示已选择的设备列表
    showChoosedDialog(){
      this.choosedDialog = true
    },
    toggleChecked(){
      this.$nextTick(() => {
        this.$refs.tableData.clearSelection()
        this.tableData.forEach((row) => {
          if (this.choosedIdList.indexOf(row.id) >= 0) {
            this.$refs.tableData.toggleRowSelection(row, true)
          }
        })
      })
    },
    // 操作设备列表时，会操作到数组
    handleCheckChangeEquipmentParameter(data, checked, indeterminate) {
    },
    handleCheckChangeKeyConfig(data, checked, indeterminate) {
    },
    handleNodeClick(data) {
      console.log(data);
    },
    copyPartData(){
      this.reloading = this.openLoading(this.$t('equipmentmanagement.dataSavingPleaseWait')+'......')
      // 获取选中的设备参数
      let tempNodeP = this.$refs. equipmentTree.getCheckedNodes()
      tempNodeP.forEach(item=>{
        this.needCopyEquipmentParameterArr.push({variableName:item.variableName,value:item.value,multiple:item.multiple?item.multiple:1})
      })
      let tempNodeK = this.$refs.keyConfigTree.getCheckedNodes()
      tempNodeK.forEach(item=>{
        if(!(item.keyConfigValuePairs && item.keyConfigValuePairs.length>0)){
          this.needCopyKeyConfigArr.push({keySort:item.keySort,variableName:item.variableName,value:item.value,sort:item.sort,multiple:item.multiple?item.multiple:1})
        }
      })
      this.$httpservice.post('api/Equipment/CopyPartParameter',{"ids":this.choosedIdList,"equipmentParameters":this.needCopyEquipmentParameterArr,"keyConfigValuePairs":this.needCopyKeyConfigArr}).then(res=>{
        if(res.body.code == 200){
          this.$message.success(res.body.msg)
          this.reloading.close()// 关闭loading框
        }else{
          this.$message.error(res.body.msg)
          this.reloading.close()// 关闭loading框
        }
      })
      this.needCopyEquipmentParameterArr = []
      this.needCopyKeyConfigArr = []
    },
    // 复制dtu设备的部分或全部按键
    copyDtuData(){
      let data = {}
      data.ids = this.choosedIdList
      data.id = this.equipmentCopyInit.id
      data.type = 2
      data.sortList = this.dtuCheckList
      this.$httpservice.post("api/Alpha/BatchIssueKeyconfigDTU",data).then(res=>{
        console.log(res)
        if(res.body.code == 200){
          this.$message.success("下发完成，请等待设备处理")
        }else{
          this.$message.success("下发失败请重试")
        }
      })
    },
    //获取设备型号筛选
    getEquipTypeList(){
      let that = this;
      this.$httpservice.get("api/Equipment/EquipmentTypes").then(
        function (data) {
          if(data.body.code=="200"){
            that.equipTypeList = data.body.data;
            that.totalEquipTypeCount = data.body.totalCount;
            //销售渠道名称筛选数组
            for(let index in that.equipTypeList){
              that.equipfilterdata.push({
                text: that.equipTypeList[index].name,
                value: that.equipTypeList[index].id
              });
            }
          }else{
            that.$message({
              message: data.body.msg,
              type: 'danger'
            });
          }
        },
        function (data) {
          that.userListloading = false;
          let statusCode = data.status;
          that.$message({
            message: that.$t('queryFailedStatusCode')+statusCode,
            type: 'warning'
          });
        }
      );
    },
    // 修改选中的按键
    changeDtuList(){
      console.log(this.dtuCheckList)
    }
  },
  watch:{
    choosedIdList:function (){

    }
  },
}
</script>

<style lang="less">
  #equipmentCopy{
    background-color: #f5f5f5;
    .el-badge{
      vertical-align: baseline;
      border: 1px solid #98adbe!important;
      border-radius: 4px;
    }
    .search{
      width: 100%;
      height: 60px;
      background-color: #f5f5f5;
      padding: 10px;
      .el-input{
        width: 200px!important;
        line-height: 40px;
      }
    }
    .table{
      width:100%;
      background-color: #f5f5f5;
    }
    .foot{
      margin: 20px 0;
      text-align: center;
      background-color: #FFFFFF;
    }
    .englishStyle{
      font-size: 12px!important;
    }
    #userForm{
      .englishStyle{
        color: red!important;
      }
    }
  }
  #partDialog{
    .el-input{
      width: 30%!important;
    }
    #button_row{
      text-align: center;
    }
    .el-tree-node__content{
      height: 30px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/equipmentmanagement/EquipmentCopy.vue